

import { Component, Inject, DOCUMENT } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationTypes } from 'src/app/app.enums';
import { ArtistPortfolioProductsService, portfolioData, ShareableProductLink } from 'src/app/Services/artist-portfolio-products/artist-portfolio-products.service';
import { artistProduct, ArtistProductsService, ArtistProductsSummaryRequest, ArtistProductSummary, ConsignedProductsRequest } from 'src/app/Services/artistproducts.service';
import { ArtistsService } from 'src/app/Services/artists.service';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { CategoryService } from 'src/app/Services/category.service';
import { ConsignmentService, GalleryConsignmentProduct } from 'src/app/Services/consignment.service';
import { GalleryPersonlaProduct, GalleryProductService } from 'src/app/Services/Gallery-Products-Service/galleryproduct.service';
import { SeriesService } from 'src/app/Services/series.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { SubscriptionRulesService } from 'src/app/Services/subscription-rules.service';
import { TranslocoService } from '@jsverse/transloco';
@Component({
    selector: 'shareable-product',
    templateUrl: './gallery-sharable-products.component.html',
    styleUrls: ['./gallery-shareable-products.component.css'],
    providers: [ArtistsService, ArtistProductsService, GalleryProductService, SeriesService, CategoryService, SubscriptionRulesService],
    standalone: false
})
export class GalleryShareableProductComponent {
    public galleryProducts: GalleryConsignmentProduct[] = [];
    public sharebleProductLinks: ShareableProductLink[]=[];
    public selectedGalleryProductsInventory: GalleryConsignmentProduct[] = [];
    public filters: ArtistProductsSummaryRequest = {};
    public selectedProducts: string[] = [];
    public artistId!: string;
    public galleryId!: string;
    public selectedColumnCount: number | null = null;
    public isArtist: boolean = false;
    public isGallery: boolean = false;
    public isProductSelected: boolean = false;
    public isCurrentInventoryLoaded: boolean = false;
    public isPageConfigrationDailogVisible: boolean = false;
    public isShareableProductDailogVisible: boolean = false;
    // public isEditMode: boolean = false;
    public isShowProfile!: boolean;
    public loadingArtistProducts: boolean = false;
    public loadingGalleryProducts: boolean = false;
    public currentAvailableArtworks: number = 0;
    public authConfig: AuthConfig = {};
    public shareableProductFormData!: ShareableProductLink;
    public copiedIndex: string | null = null;
    public isLoading: boolean = true;


    constructor(
        private router: Router,
        private authService: AuthService,
        private ArtistProductsService: ArtistProductsService,
        private ngxSpinnerService: NgxSpinnerService,
        private notificationsService: NotificationsService,
        private consignmentService: ConsignmentService,
        private artistPortfolioProductsService: ArtistPortfolioProductsService,
        private transloco: TranslocoService,

        @Inject(DOCUMENT) private document: Document
    ) {
        this.shareableProductFormData = new ShareableProductLink();
    }

    public ngOnInit(): void {
        this.authConfig = this.authService.getAuthConfig();
        if (this.authConfig.IsGallery) {
            this.getGalleryConsignmentProducts();
            this.galleryId = this.authService.getUserId();
            console.log(this.galleryId)
        }
        this.getPortFolioData();
    }
    public selectInventory(event: GalleryConsignmentProduct) {
        // Check if the selected inventory item is not already in the array
        if (!this.selectedGalleryProductsInventory.some(item => item.Product.Id === event.Product.Id)) {
            // Move the product to selectedInventory
            this.selectedGalleryProductsInventory.push(event);
            // Add the product's ID to selectedProducts array
            this.selectedProducts.push(event.Product.Id);
            // Remove the selected item from currentInventory
            const index = this.galleryProducts.findIndex(item => item.Product.Id === event.Product.Id);
            if (index !== -1) {
                this.galleryProducts.splice(index, 1);
            }
            this.isProductSelected = true;
            console.log('Selected Product IDs:', this.selectedProducts);
        }
    }

    public moveToCurrentInventory(selectedGalleryProductsInventory: GalleryConsignmentProduct) {
        // Find the index of the item in the selectedInventory array
        const currentIndex = this.selectedGalleryProductsInventory.findIndex(item => item.Product.Id === selectedGalleryProductsInventory.Product.Id);
        // If the item is found, remove it from selectedInventory and add it to currentInventory
        if (currentIndex !== -1) {
            const removedItem = this.selectedGalleryProductsInventory.splice(currentIndex, 1)[0];
            // Remove the product's ID from selectedProducts array
            const idIndex = this.selectedProducts.findIndex(id => id === removedItem.Product.Id);
            if (idIndex !== -1) {
                this.selectedProducts.splice(idIndex, 1);
            }
            this.galleryProducts.push(removedItem);
            this.isProductSelected = this.selectedGalleryProductsInventory.length > 0;
            console.log('Selected Product IDs:', this.selectedProducts);
        }
    }

    generateLink() {
        // Check if there are selected products
        if (this.selectedProducts.length === 0) {
            console.log('No products selected to generate the link.');
            this.notificationsService.showNotification(this.transloco.translate('galleryShareableProducts.noProductsSelectedTitle'), this.transloco.translate('galleryShareableProducts.noProductsSelectedMessage'), NotificationTypes.Error);
            return;
        }
        this.isPageConfigrationDailogVisible = true
        this.shareableProductFormData.ProductIds = this.selectedProducts
        console.log(this.shareableProductFormData)
        this.ngxSpinnerService.show();
        this.ArtistProductsService.ArtistShareAvailableProduct(this.shareableProductFormData).subscribe(
            (response) => {
                this.ngxSpinnerService.hide();
                console.log('Successfully generated the link:', response);
                if (response.Success && response.ResponseData) {
                    this.generatedLinkId = response.ResponseData;

                    console.log('Generated Link ID:', this.generatedLinkId);
                    this.isProductShareDailogVisible = true;
                } else {
                    this.notificationsService.showNotification(this.transloco.translate('galleryShareableProducts.linkGenerationFailedTitle'), response.ResponseMessage, NotificationTypes.Error);
                }
            },
            (error) => {
                this.ngxSpinnerService.hide();
                console.error('Failed to generate the link:', error);
                this.notificationsService.showNotification(this.transloco.translate('galleryShareableProducts.linkGenerationFailedTitle'), this.transloco.translate('galleryShareableProducts.linkGenerationFailedMessage'), NotificationTypes.Error);
            }
        );
    }

    public getGalleryConsignmentProducts(artistId: string | null = null, filters: ConsignedProductsRequest = {}) {
        this.isLoading = true;
        this.ngxSpinnerService.show();
        console.log(artistId)
        this.consignmentService.getGalleryConsignmentProducts(artistId, filters).subscribe((galleryProducts: GalleryConsignmentProduct[]) => {
            console.log(galleryProducts)
            this.galleryProducts = galleryProducts;

            console.log('galleryProducts', this.galleryProducts);
            this.isLoading = false;
            this.ngxSpinnerService.hide();
        }, (error) => { console.error(error); this.isLoading = false; this.ngxSpinnerService.hide(); });
    }

    public isProductShareDailogVisible = false
    generatedLinkId!: string;

    public onProductShareDailog() {
        this.isProductShareDailogVisible = true
    }

    public onCloseProductShareDailog($event: any) {
        this.isProductShareDailogVisible = $event
    }

    public createNewProduct() {
        this.router.navigate(['/gallery-product', 'create']);
    }


    public showProductDetail(artistProduct: GalleryConsignmentProduct) {
        this.router.navigate([artistProduct.Product.ArtistId, 'artworks', artistProduct.Product.Id]);
    }

    public onShowPageConfigrationDailog() {
        this.isPageConfigrationDailogVisible = true
    }

    public onClosePageConfigrationsDailog() {
        this.isPageConfigrationDailogVisible = false
        this.shareableProductFormData = new ShareableProductLink();
        this.isShowProfile = false
        this.selectedColumnCount = null
        // this.isEditMode = false
    }

    public onColumnCountChange(event: number | null) {
        console.log("Selected Column Count:", event);
        this.shareableProductFormData.NumberOfColumnToShow = event
    }

    public onShowProfileChange(event: any) {
        console.log("Show Profile:", event.checked);
        this.shareableProductFormData.IsShowProfile = event.checked
    }
    public portfolioList: portfolioData[] = [];

    public getPortFolioData() {
        this.ngxSpinnerService.show();
        this.artistPortfolioProductsService.getPortFolioData().subscribe((portfolioList: portfolioData[]) => {
            this.ngxSpinnerService.hide();
                console.log(portfolioList)
                this.portfolioList = portfolioList
                console.log('this.portfolioDataInformation', this.portfolioList)
            },
            (error) => {console.error(error);this.ngxSpinnerService.hide()}
        );
    }

    public onShowShareableProductDailog(){
        this.isShareableProductDailogVisible = true
    }

    public onCloseShareableProductDailog(){
        // this.selectedGalleryProductsInventory = []
        this.isShareableProductDailogVisible = false
    }


}
